import { render, staticRenderFns } from "./threeCourse.vue?vue&type=template&id=49a03b70&scoped=true"
import script from "./threeCourse.vue?vue&type=script&lang=js"
export * from "./threeCourse.vue?vue&type=script&lang=js"
import style0 from "./threeCourse.vue?vue&type=style&index=0&id=49a03b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a03b70",
  null
  
)

export default component.exports